<template>
  <div class="container-pay" :style="cssVars()">
    <div class="custom-nav-block" :style="`paddingTop: ${barHeight}px`">
      <van-nav-bar class="van-bar" left-trangle @click-left="goBack" @click-right="goCustomer">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
          <span class="tit-left">{{ $t('lang.commonM.k368') }}</span>
        </template>

        <template #right>
          <img class="icon-right" src="@/assets/packageAssets/views/P1_Boys/PayNext/default/customer.png" alt="" />
        </template>
      </van-nav-bar>
    </div>

    <div class="main">
      <div class="pay">
        <div class="money-block">
          <img class="moneys" :src="getMatchImg('coin')" alt="" />
          <div class="amount">{{ myPlus(amount, presentAmount) }}</div>
          <div v-if="presentAmount > 0" class="origin-amount">
            <div class="old-amount">{{ amount }}</div>
            <div class="extra-amount">+{{ presentAmount }}</div>
          </div>
        </div>
        <div class="pay-other">
          <template v-for="(item, index) in presentPropList">
            <div v-if="item.propType == 1" class="dis-item">
              <img :src="getMatchImg('chat-pass')" />
              x{{ item.number }}
            </div>
            <div v-else-if="item.propType == 2" class="dis-item">
              <img :src="getMatchImg('video-pass')" />
              x{{ item.number }}
            </div>
            <div v-else-if="item.propType == 4" class="dis-item">
              <img :src="getMatchImg('vip')" />
              x{{ item.number }}
            </div>
            <div v-else-if="item.propType == 6" class="dis-item">
              <img :src="getMatchImg('call-pass')" />
              x{{ item.number }}
            </div>
            <div v-else-if="item.propType == 9" class="dis-item">
              <img :src="getMatchImg('coupon')" />
              x{{ item.number }}
            </div>
            <div v-else-if="item.propType == 15" class="dis-item">
              <img :src="getMatchImg('super-chat-pass')" />
              x{{ item.number }}
            </div>
          </template>
        </div>
        <div class="tips-one">{{ $t('lang.commonM.k369') }}</div>
      </div>

      <!-- todo 样式先写，接口还未支持 -->
      <!-- <div class="pay-card">
        <div class="card-tag">New subscriber offer</div>
        <div class="card-main">
          <div class="card-amount">TRY 199</div>
          <div class="card-discount">
            <div>TRY 300</div>
            <div>For 1-Month VIP</div>
          </div>
        </div>
        <div class="card-gifts">
          <div class="gift-item">
            <img :src="getMatchImg('vip')" />
            &nbsp;
            <i>x20 Match Pass/day</i>
          </div>

          <div class="gift-item">
            <img :src="getMatchImg('vip')" />
            &nbsp;
            <i>x20 Match Pass/day</i>
          </div>

          <div class="gift-item">
            <img :src="getMatchImg('vip')" />
            &nbsp;
            <i>x20 Match Pass/day</i>
          </div>
        </div>
      </div> -->

      <!-- Coupons -->
      <div class="block-title">
        <div>{{ $t('lang.commonM.k370') }}</div>
        <div class="looping-container">
          <div class="looping-text">{{ $t('lang.commonM.k387') }}</div>
        </div>
      </div>

      <div class="coupons-block">
        <!-- 优惠券入口 -->
        <div :class="{ 'show-item': true, 'color-border': showCoupons }" @click="handleClickCouponEnter">
          <!-- 有可用优惠券 -->
          <template v-if="selectedCoupon">
            <div class="coupon-logo">
              <img :src="getMatchImg('coupon')" />
            </div>

            <div class="coupon-info">
              <MyPLabel class="info-main" :str="selectedCoupon.descV2" :customClass="{ coin: 'pay-coin-icon' }" />
            </div>
          </template>
          <!-- 无可用优惠券 -->
          <template v-else>
            <div class="coupon-logo">
              <img :src="getMatchImg('coupon-off')" />
            </div>

            <div class="coupon-info no-valid-info">
              <span class="info-main">{{ $t('lang.intimate.noValidCou') }}</span>
            </div>
          </template>
          <div class="coupon-arrow" :class="[showCoupons ? 'arrow-up' : '']"></div>
        </div>

        <!-- 优惠券列表 -->
        <div v-if="showCoupons" class="coupon-scroll">
          <div
            v-for="(item, index) in validCouponList"
            :key="item.couponRecordId"
            :class="{ 'coupon-item': true, 'coupon-acitve': selectedCoupon && item.couponRecordId === selectedCoupon.couponRecordId }"
            @click="handleSelectCoupon(item)"
          >
            <!-- 可用 -->
            <div v-if="item.canUse === true" class="coupon-con">
              <!-- <img class="coupon" :src="getMatchImg('coupon')" /> -->
              <div class="coupon-info">
                <MyPLabel class="info-main" :str="item.descV2" :customClass="{ coin: 'pay-coin-icon' }" />
              </div>
            </div>
            <!-- 无用 -->
            <div v-else class="coupon-con no-valid-coupon">
              <!-- <img class="coupon" :src="getMatchImg('coupon-off')" /> -->
              <div class="coupon-info">
                <MyPLabel class="info-main" :str="item.descV2" :customClass="{ coin: 'pay-coin-icon' }" />
                <span class="info-tips">This item is not supported</span>
              </div>
            </div>

            <div v-if="selectedCoupon && item.couponRecordId === selectedCoupon.couponRecordId" class="coupon-check checked"></div>
            <div v-else class="coupon-check not-checked"></div>
          </div>
        </div>
      </div>

      <!-- Methods -->
      <div class="block-title">
        <div>{{ $t('lang.commonM.k371') }}</div>
        <!-- <div>why there are different methods？</div> -->
      </div>

      <!-- 原始展开逻辑v-if="index <= beforeOriginPayIndex && item.priority <= currentPayTypeLevel" -->
      <template v-for="(item, index) in payList">
        <div
          v-if="index <= beforeOriginPayIndex"
          :key="index"
          :class="['method-item', item.ifBestPrice === true ? 'best-type' : '', index === selectedIndex ? 'method-on' : '']"
          @click.prevent="handleSelectPay(item, index)"
        >
          <div class="method-check" :class="[index === selectedIndex ? 'checked' : '']"></div>
          <div class="method-con">
            <div class="method-img"><img :src="item.icon | imgPath" alt="" /></div>
            <div class="method-name" v-if="item.icon">
              <div class="method-info">
                <div class="name">{{ item.name }}</div>
                <div v-if="item.label" class="discount">{{ item.label }}</div>
              </div>
              <div class="rate">{{ item.currency }}&nbsp;{{ handleDiv100(item.price) }}</div>
            </div>
          </div>
          <MyPLabel v-if="item.ifBestPrice === true" class="method-tips" :str="$t('lang.commonM.k385')" :customClass="{ coin: 'pay-coin-icon' }" />
        </div>
      </template>

      <div
        v-if="googlePrice"
        :class="['method-item', selectedIndex === 9999 ? 'method-on' : '']"
        @click.prevent="handleSelectPay({ currency: googleCurrency, price: myTimes(googlePrice, 100), currencyPrice: googleCurrencyCurrency }, 9999)"
      >
        <div class="method-check" :class="[selectedIndex === 9999 ? 'checked' : '']"></div>
        <div class="method-con">
          <div class="method-img">
            <img v-if="env.isAppIOS" src="@/assets/packageAssets/common/apple_pay.png" alt="" />
            <img v-else src="@/assets/packageAssets/common/google.png" alt="" />
          </div>
          <div class="method-name">
            <div class="method-info">
              <span class="name">{{ env.isAppIOS ? 'Apple Pay' : 'Google Pay' }}</span>
            </div>

            <!-- 符号与金额不匹配问题-兼容 -->
            <div v-if="googleCurrencyCurrency" class="rate">{{ googleCurrencyCurrency }}</div>
            <div v-else class="rate">{{ googleCurrency }} {{ googlePrice }}</div>
          </div>
        </div>
      </div>

      <!-- 原始展开逻辑v-if="index > beforeOriginPayIndex && item.priority <= currentPayTypeLevel" -->
      <template v-for="(item, index) in payList">
        <div
          v-if="index > beforeOriginPayIndex"
          :key="index"
          :class="['method-item', item.ifBestPrice === true ? 'best-type' : '', index === selectedIndex ? 'method-on' : '']"
          @click.prevent="handleSelectPay(item, index)"
        >
          <div class="method-check" :class="[index === selectedIndex ? 'checked' : '']"></div>
          <div class="method-con">
            <div class="method-img"><img :src="item.icon | imgPath" alt="" /></div>
            <div class="method-name" v-if="item.icon">
              <div class="method-info">
                <div class="name">{{ item.name }}</div>
                <div v-if="item.label" class="discount">{{ item.label }}</div>
              </div>
              <div class="rate">{{ item.currency }} {{ handleDiv100(item.price) }}</div>
            </div>
          </div>
          <MyPLabel v-if="item.ifBestPrice === true" class="method-tips" :str="$t('lang.commonM.k385')" :customClass="{ coin: 'pay-coin-icon' }" />
        </div>
      </template>

      <!-- <div v-if="showMore" class="method-more">
        <div class="trangle" :class="{ 'trangle-down': currentPayTypeLevel !== lastPayTypeLevel }" @click="showMorePay"></div>
      </div> -->

      <!-- 底部栏占位用 -->
      <div style="width: 100%; height: 300px"></div>

      <div class="submit-btn-block">
        <!-- prettier-ignore -->
        <div class="submit-btn" @click="handleClickPay">
          {{ $t('lang.host.get')}} {{ myPlus(amount, presentAmount) }} <img :src="getMatchImg('coin')" />
          <template v-if="selectedItem">
            <template v-if="selectedItem.currencyPrice">({{selectedItem.currencyPrice}})</template> 
            <template v-else>({{selectedItem.currency}}&nbsp;{{handleDiv100(selectedItem.price)}})</template> 
          </template>
          <van-loading v-if="loadingShow" type="spinner" color="#ffffff" class="pay-loading" size="20px" />
        </div>
        <div :style="{ height: `${bottomBarHeight || 30}px` }"></div>
      </div>
    </div>

    <!-- 支付结果弹窗 -->
    <PayResult :showDiaC="showResultDia" :oneShow="true" :title="payResultText" />
  </div>
</template>

<script>
// 多包样式
import { pageCssVars } from '@/views/P1_Boys/PayNext/z-style-cfg.js'

import { apiFetchPayList, apiFetchShopOrder } from '@/api/imee'
import { mixin } from './base.mixin.js'

import _debounce from 'lodash/debounce'

import PayResult from '@/components/CConfirm/PayResult.vue'

function strToNum(str) {
  let result = null
  if (str) {
    // prettier-ignore
    try {
      result = str * 1
    }
    catch (err) {
      result = null
    }
  }
  return result
}

export default {
  mixins: [pageCssVars, mixin],
  components: { PayResult },
  data() {
    const query = this.$route.query
    return {
      // 产品信息
      gid: query.gid || null,
      productId: null,

      // 优惠信息
      amount: 0,
      presentAmount: 0,
      presentPropList: [],

      // 方式-三方
      lastUsedChannel: '',
      payList: [],
      selectedIndex: -1,
      selectedItem: null,

      // 方式-google/apple
      googlePrice: query.price || null,
      googleCurrency: query.currency || null,
      googleCurrencyCurrency: query.currencyPrice || null,

      // 控制参数-提示loading
      loadingShow: false,

      // 支付方式统计
      selectChannelIndex: -1
    }
  },
  methods: {
    fetchPayList() {
      if (!this.gid) {
        return
      }

      const resolvePayList = (res, fromApi) => {
        this.productId = res.productId
        this.amount = res.amount || 0
        this.presentAmount = res.presentAmount || 0
        this.presentPropList = res.presentPropListV2 || []
        this.lastUsedChannel = res.lastUsedChannel
        this.payList = res.payChannelList || []

        // 渲染缓存数据，不处理优惠券
        fromApi && this.initCoupon()

        this.sortPayType()

        this.selectedBestPayType()

        // this.initMore()
      }

      // 读取web localstorage缓存
      const uid = this.getUid() || 'unknown'
      const localRes = window.localStorage.getItem(`payList_${uid}_${this.gid}`)
      if (this.gid && localRes) {
        resolvePayList(JSON.parse(localRes))
      }

      apiFetchPayList({
        gid: this.gid,
        activityType: this.$route.query.activityType,
        tierId: this.$route.query.tierId || null,
        shopType: this.getShopType()
      }).then((res) => {
        if (res && res.payChannelList) {
          // 写入web localstorage缓存
          window.localStorage.setItem(`payList_${uid}_${this.gid}`, JSON.stringify(res))

          resolvePayList(res, true)
        }
      })
    },

    queryGoogleProductListCallback(res) {
      if (res) {
        try {
          const googlePayList = JSON.parse(res)
          const targetItem = googlePayList.find((item) => {
            return this.$route.query.productId == item.productId
          })
          if (targetItem) {
            this.googlePrice = targetItem.price
            this.googleCurrency = targetItem.currencyCode
            this.googleCurrencyCurrency = targetItem.currencyPrice
          }
        } catch (err) {
          console.log('try catch err:', err)
        }
      }
    },

    handleSelectPay(item, index) {
      this.selectedItem = item
      this.selectedIndex = index
    },

    handleClickPay() {
      if (this.selectedIndex > -1) {
        const tempKeys = Object.keys(this.selectedItem)
        // thirdpay
        if (tempKeys && tempKeys.length && this.selectedIndex !== 9999) {
          this.thirdPay(this.selectedItem)
        }
        // googlpay/applepay
        else {
          this.originPay()
        }
      }
    },

    thirdPay: _debounce(
      function (item) {
        let payChannelTotal = null
        if (this.payList && this.payList.length) {
          payChannelTotal = this.payList.length
        }
        let payChannelIndex = null
        if (this.selectChannelIndex != -1 && payChannelTotal !== null && payChannelTotal !== 0) {
          payChannelIndex = payChannelTotal - 1 - this.selectChannelIndex
        }
        if (this.googlePrice && this.googleCurrency && payChannelTotal !== null && payChannelIndex !== null) {
          payChannelTotal = payChannelTotal + 1
          payChannelIndex = payChannelIndex + 1
        }

        let data = {
          tierId: this.$route.query.tierId || null,
          shopType: this.$route.query.shopType || null,
          gid: this.gid,
          payType: item.payType,
          scene: this.scene,
          thirdParam: this.thirdParam,
          payChannel: item.name,
          payChannelIndex: payChannelIndex,
          payChannelTotal: payChannelTotal
        }
        if (this.$route.query.videoChatScene) {
          data.videoChatScene = this.$route.query.videoChatScene
        }
        if (this.$route.query.activityType) {
          data.activityType = this.$route.query.activityType
        }
        if (this.selectedCoupon && this.scene != 'activity') {
          data.couponRecordId = this.selectedCoupon.couponRecordId
        }
        if (this.scene == 'activity') {
          data.shopType = 7
        }
        this.$client.addEvent('top_up', {
          Action: 'Click',
          APosition: 'payButton',
          productID: this.productId,
          goodtype: 'coin',
          from: 'cash',
          paymethod: item.name
        })

        if (this.loadingShow === true) {
          return
        }

        this.loadingShow = true

        apiFetchShopOrder(data)
          .then((res) => {
            // 下单后刷新优惠券
            this.initCoupon()

            if (res && !res.error) {
              const openInExternalBrowser = res.credential?.openInExternalBrowser || false
              const wapUrl = res.credential?.wapUrl || ''
              // 外部浏览器打开
              if (openInExternalBrowser) {
                this.appAction('open_web_outside', `?url=${wapUrl}`)

                // 调用三方支付后，无法检测支付状态，直接关闭web
                if (['10', '18', '19', '27'].includes(this.$route.query.activityType)) {
                  this.closeWeb()
                }
              }
              // webview打开
              else {
                if (wapUrl) {
                  this.$router.push({
                    path: '/pay-code',
                    query: { url: wapUrl }
                  })
                }
              }
            }
          })
          .finally(() => {
            this.loadingShow = false
          })
      },
      2000,
      {
        leading: true,
        trailing: false
      }
    ),

    // googlePay applePay 要客户端提供方法
    originPay() {
      // 从 h5 活动页进入，客户端不知道商品信息，不知道优惠券信息
      if (this.$route.query.useWebPay == '1') {
        const params = {
          gid: this.gid,
          productId: this.$route.query.productId || '',
          activityType: this.$route.query.activityType * 1,
          scene: this.$route.query.scene || '',
          tierId: strToNum(this.$route.query.tierId),
          shopType: this.$route.query.shopType || null
        }

        // todo 注释原因：活动不会获取优惠券
        // if (this.maxCoupon) {
        //   params.couponRecordId = this.maxCoupon.couponRecordId
        // }

        // echo
        if (this.packageName === 'echo') {
          nativePaymentFromWeb.postMessage(JSON.stringify(params))
        }
        // 其他包
        else {
          payGoogleFromWeb.postMessage(JSON.stringify(params))
        }

        // 调用原生支付后，客户端支付完成后，web可以监听window.refresh
        // 回到上级活动页面，后续逻辑由活动页面处理
        if (['10', '18', '19', '27'].includes(this.$route.query.activityType)) {
          this.goPrevious()
        }
      }
      // 从客户端商品列表进入，客户端知道商品信息，不知道优惠券信息
      else {
        const params = {
          tierId: strToNum(this.$route.query.tierId),
          shopType: this.$route.query.shopType || null
        }

        if (this.selectedCoupon) {
          params.couponRecordId = this.selectedCoupon.couponRecordId
        }

        // echo
        if (this.packageName === 'echo') {
          nativePayment.postMessage(JSON.stringify(params))
        }
        // 其他包
        else {
          payGoogle.postMessage(JSON.stringify(params))
        }
      }
    },

    refresh() {
      this.init()
    },

    init() {
      this.fetchPayList()
    }
  },
  created() {
    this.init()

    // 客户端回调刷新
    window.refresh = this.refresh

    // 获取客户端原生支付
    if (this.packageName === 'echo') {
      window.queryProductListCallback = this.queryGoogleProductListCallback
    }
    //
    else {
      window.queryGoogleProductListCallback = this.queryGoogleProductListCallback
    }

    if (!this.$route.query.price && this.$route.query.productId) {
      this.$client.googleProductList([this.$route.query.productId], this.packageName)
    }
  }
}
</script>
<style lang="scss" scoped>
.container-pay {
  width: 100%;
  min-height: 100vh;
  background: var(--pay-bg1, #f9f9fb);

  .custom-nav-block {
    background-color: var(--pay-bg1, #f9f9fb);

    .tit-left {
      font-family: var(--base-fontfamily, 'Inter Tight');
      color: var(--pay-color0, #333333);
    }

    .icon-right {
      box-sizing: content-box;
      width: 25px;
      height: 25px;
    }
  }

  .main {
    padding: 0 18px 20px;
  }

  .pay {
    width: 100%;
    margin: 40px 0;
    .money-block {
      display: flex;
      align-items: center;
      justify-content: center;

      font-family: var(--base-fontfamily, 'Inter Tight');

      .moneys {
        width: 48px;
        height: 48px;
      }
      .amount {
        color: var(--pay-color1, #333333);
        font-size: 28px;
        font-weight: 600;
        line-height: 32px;
        margin: 0 6px;
      }

      .origin-amount {
        height: 32px;
        display: flex;
        align-items: flex-end;
        .old-amount {
          color: var(--pay-color2, #333333);
          font-size: 16px;
          font-weight: bold;
          line-height: 24px;
        }
        .extra-amount {
          color: var(--pay-color3, #ff4265);
          font-size: 16px;
          font-weight: bold;
          line-height: 24px;
        }
      }
    }
    .pay-other {
      margin-top: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      gap: 16px;

      .dis-item {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;

        color: var(--pay-color4, #333333);
        font-family: var(--base-fontfamily, 'Inter Tight');
        font-size: 16px;
        font-style: normal;
        font-weight: bold;
        line-height: 18px;

        img {
          width: 28px;
        }
      }
    }
    .tips-one {
      width: 343px;
      margin: 8px auto 0;

      color: var(--pay-color5, #b2b2b2);
      font-family: var(--base-fontfamily, 'Inter Tight');
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
    }
  }

  // .pay-card {
  //   width: 343px;
  //   margin: 16px auto;
  //   padding: 16px;
  //   border-radius: 16px;
  //   background: linear-gradient(121deg, #0a4a46 -25.85%, rgba(10, 74, 70, 0) 57.36%), linear-gradient(180deg, #0b2e72 0%, rgba(11, 45, 116, 0) 100%), #4c1c73;
  //   .card-tag {
  //     display: inline-block;
  //     padding: 0 11px;
  //     color: #fff;
  //     -webkit-text-stroke-width: 0.5px;
  //     font-family: var(--base-fontfamily, 'Inter Tight');
  //     font-size: 12px;
  //     font-style: italic;
  //     letter-spacing: 1px;
  //     font-weight: bold;
  //     line-height: 20px;
  //     background: var(--icon-tag-bg) top left / 100% auto no-repeat;
  //   }
  //   .card-main {
  //     margin-top: 24px;
  //     display: flex;
  //     align-items: flex-end;
  //     justify-content: space-between;
  //     .card-amount {
  //       color: var(--System-Color-White, #fff);
  //       font-family: var(--base-fontfamily, 'Inter Tight');
  //       font-size: 32px;
  //       font-style: normal;
  //       font-weight: 700;
  //       line-height: 40px;
  //     }
  //     .card-discount {
  //       display: flex;
  //       align-items: center;
  //       justify-content: flex-end;

  //       color: var(--System-Color-White-All, #fff);
  //       font-family: var(--base-fontfamily, 'Inter Tight');
  //       font-size: 15px;
  //       font-style: normal;
  //       font-weight: bold;
  //       line-height: 18px;
  //       div {
  //         &:nth-child(1) {
  //           text-decoration: line-through;
  //         }
  //         &:nth-child(2) {
  //           margin: 0 8px;
  //         }
  //       }
  //     }
  //   }
  //   .card-gifts {
  //     margin-top: 16px;
  //     overflow: hidden;
  //     .gift-item {
  //       float: left;
  //       width: 50%;
  //       display: flex;
  //       align-items: center;
  //       overflow: hidden;
  //       margin-top: 8px;

  //       color: var(--System-Color-White-All, rgba(255, 255, 255, 0.7));
  //       font-family: var(--base-fontfamily, 'Inter Tight');
  //       font-size: 12px;
  //       font-style: normal;
  //       font-weight: bold;
  //       line-height: 18px;
  //       img {
  //         width: 16px;
  //       }
  //     }
  //   }
  // }

  .block-title {
    display: flex;
    align-items: flex-start;
    margin-top: 32px;
    div {
      &:nth-child(1) {
        width: 120px;
        color: var(--pay-color6, #333333);
        font-family: var(--base-fontfamily, 'Inter Tight');
        font-size: 17px;
        font-weight: bold;
        line-height: 20px;
      }
      &:nth-child(2) {
        width: 240px;
        font-family: var(--base-fontfamily, 'Inter Tight');
        font-size: 15px;
        font-weight: 400;
        line-height: 20px;
        text-align: left;
        white-space: nowrap;
      }
    }
    .looping-container {
      width: 240px;
      height: 20px;
      overflow: hidden;

      .looping-text {
        animation: slideLeft 9s linear infinite;
        width: fit-content;
        padding: 0 30px;
        color: var(--pay-color7, #b2b2b2);
        font-family: var(--base-fontfamily, 'Inter Tight');
        font-size: 15px;
        font-weight: 300;
        line-height: 20px;
        white-space: nowrap;
      }
    }
  }

  .coupons-block {
    margin: 12px auto 0;
    background: var(--pay-bg2, #fefefe);
    border-radius: 8px;
    overflow: visible;
    position: relative;

    .show-item {
      position: relative;
      z-index: 2;
      padding: 16px;
      display: flex;
      align-items: center;
      border-radius: 8px;
      background: var(--pay-bg2, #fefefe);
      // box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.12);
      .coupon-logo {
        width: 44px;
        height: 44px;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--pay-bg3, #f4f5f7);
        img {
          width: 24px;
        }
      }

      .coupon-info {
        flex: 1;
        margin: 0 12px;
        .info-main {
          color: var(--pay-color8, #666666);
          font-family: var(--base-fontfamily, 'Inter Tight');
          font-size: 14px;
          font-weight: 500;
          line-height: 18px;
        }

        .info-tips {
          color: var(--pay-color9, #b2b2b2);
          font-family: var(--base-fontfamily, 'Inter Tight');
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 14px;
        }
      }

      .no-valid-info {
        .info-main {
          color: var(--pay-color9, #b2b2b2);
        }
      }

      .coupon-arrow {
        width: 16px;
        height: 16px;
        background: var(--icon-arrow) top left / 100% 100% no-repeat;
        transform: rotateZ(180deg);
        &.arrow-up {
          transform: rotateZ(0deg);
        }
      }
    }

    // .color-border {
    //   border: 1px solid #a338fc;
    // }

    .coupon-scroll {
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: 999;
      width: 100%;
      transform: translateY(102%);
      border-radius: 8px;
      background-color: var(--pay-bg4, #ffffff);
      box-shadow: 0 4px 8px 0 rgba(79, 82, 90, 0.25);
      max-height: 190px;
      padding-bottom: 5px;
      overflow-y: auto;

      .coupon-item {
        padding: 16px;
        margin: 4px 4px 0 4px;
        display: flex;
        align-items: center;
        border-radius: 8px;
        .coupon-check {
          width: 16px;
          height: 16px;
          &.checked {
            background: var(--icon-check) top left / 100% 100% no-repeat;
          }
          &.not-checked {
            background: var(--icon-not-check) top left / 100% 100% no-repeat;
          }
        }
        .coupon-con {
          flex: 1;
          display: flex;
          align-items: center;
          padding: 0 5px;
          .coupon {
            width: 20px;
            margin: 0 4px;
          }
          .coupon-info {
            .info-main {
              color: var(--pay-color8, #666666);
              font-family: var(--base-fontfamily, 'Inter Tight');
              font-size: 15px;
              font-style: normal;
              font-weight: 500;
              line-height: 18px;
            }

            .info-tips {
              color: var(--pay-color9, #b2b2b2);
              font-family: var(--base-fontfamily, 'Inter Tight');
              font-size: 12px;
              font-style: normal;
              font-weight: 400;
              line-height: 14px;
            }
          }
        }
        .no-valid-coupon {
          .coupon-info {
            .info-main {
              color: var(--pay-color9, #b2b2b2);
            }
          }
        }
        .coupon-arrow {
          width: 16px;
          height: 16px;
          background: var(--icon-arrow) top left / 100% 100% no-repeat;
          transform: rotateZ(180deg);
          &.arrow-up {
            transform: rotateZ(0deg);
          }
        }
      }

      .coupon-acitve {
        background: var(--pay-bg3, #f4f5f7);
      }
    }
  }

  .method-item {
    width: 100%;
    margin-top: 12px;
    border-radius: 10px;
    overflow: hidden;
    border: 1.5px solid transparent;
    position: relative;

    .method-tips {
      padding: 4px 10px;
      font-family: var(--base-fontfamily, 'Inter Tight');
      font-size: 12px;
      font-weight: 400;
      line-height: 14px;
      text-align: center;
      color: var(--pay-color10, #ffffff);
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
    }

    .method-check {
      position: absolute;
      top: 0;
      right: 0;
      width: 28px;
      height: 28px;
      &.checked {
        background: var(--icon-check2) top left / 100% 100% no-repeat;
      }
    }

    .method-con {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 12px;
      background: var(--pay-bg4, #ffffff);

      .method-img {
        display: flex;
        justify-content: center;
        width: 44px;
        height: 44px;
        margin-right: 12px;
        border-radius: 5px;
        background: var(--pay-bg3, #f4f5f7);
        > img {
          width: 44px;
          object-fit: contain;
        }
      }
      .method-name {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;

        .method-info {
          display: flex;
          align-items: flex-start;
          justify-content: center;
          flex-direction: column;
          .name {
            color: var(--pay-color11, #333333);
            font-family: var(--base-fontfamily, 'Inter Tight');
            font-size: 15px;
            font-weight: bold;
            line-height: 18px;
          }
          .discount {
            padding: 2px 6px;
            margin-top: 2px;
            border-radius: 2px;
            background: var(--pay-bg5, #fff5eb);

            color: var(--pay-color12, #f95151);
            font-family: var(--base-fontfamily, 'Inter Tight');
            font-size: 12px;
            font-style: normal;
            font-weight: bold;
            line-height: normal;
          }
        }

        .rate {
          color: var(--pay-color13, #333333);
          font-family: var(--base-fontfamily, 'Inter Tight');
          font-size: 15px;
          font-weight: bold;
          line-height: 18px;
          white-space: nowrap;
        }
      }
    }
  }
  .best-type {
    .method-tips {
      background: var(--pay-bg6, #a338fc);
    }
  }
  .method-on {
    border: 1.5px solid var(--pay-bg6, #a338fc);
  }

  .method-more {
    width: 100%;
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    .trangle {
      box-sizing: content-box;
      width: 16px;
      height: 16px;
      border: 12px solid transparent;
      background: var(--icon-trangle) left top / 100% auto no-repeat;
    }
    .trangle-down {
      transform: rotateZ(180deg);
    }
  }

  .submit-btn-block {
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 999;
    background: var(--pay-bg7, rgba(249, 249, 251, 0.8));
    padding-top: 20px;

    .submit-btn {
      width: 335px;
      margin: auto;
      padding: 13px 20px;
      border-radius: var(--pay-radius01, 100px);
      background: var(--pay-bg6, #a338fc);
      color: var(--pay-color14, #ffffff);
      text-align: center;
      font-family: var(--base-fontfamily, 'Inter Tight');
      font-size: 17px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 20px;
        margin: 0 3px;
      }
    }
  }
}

@keyframes slideLeft {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

::v-deep .van-nav-bar__title {
  font-size: 17px;
  font-weight: bold;
}
::v-deep .coupon-enter {
  margin-bottom: 20px;
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .container-pay .block-title div:nth-child(2) {
    text-align: left;
  }
  .container-pay .method-item .method-check {
    right: unset;
    left: 0;
  }
  .container-pay .method-item .method-con .method-img {
    margin-right: unset;
    margin-left: 12px;
  }
  .container-pay .method-item .method-check.checked {
    background: var(--icon-check3) top left / 100% 100% no-repeat;
  }
}
</style>

<style>
.pay-coin-icon {
  width: 20px;
  height: 20px;
}
</style>
